import moment from "moment";
import React, { Component } from "react";
import { Segment, Input, Table, Header, Button } from "semantic-ui-react";
import api from "../actions/api";

const intervalTime = 60;
export default class Home extends Component {
  autoReloadInterval = null;
  state = {
    autoReload: false,
    times: [],
    filtered: [],
    day: "all",
    loading: true,
  };
  componentDidMount() {
    this.enableAutoReload();
    this._getData(this.state.day);
  }
  componentWillUnmount() {
    this.disableAutoReload();
  }
  disableAutoReload = () => {
    this.setState({
      autoReload: false,
    });
    if (this.autoReloadInterval) {
      clearInterval(this.autoReloadInterval);
    }
  };
  enableAutoReload = () => {
    this.setState({
      autoReload: true,
    });
    if (!this.autoReloadInterval) {
      this.autoReloadInterval = setInterval(() => {
        this._getData(this.state.day);
      }, intervalTime * 1000);
    }
  };
  leftPad = (width, n) => {
    if ((n + "").length > width) {
      return n;
    }
    const padding = new Array(width).join("0");
    return (padding + n).slice(-width);
  };
  _getData = (day) => {
    api.leaderboard.all(day).then((times) => {
      this.setState({
        times,
        filtered: times,
        loading: false,
      });
    });
  };
  setDay = (e, { name }) => {
    this.setState({ day: name }, () => {
      this._getData(this.state.day);
    });
  };
  handleClientFilter = (e) => {
    let updatedList = this.state.times;
    if(e.target.value.toLowerCase().trim().length === 0){
      this.setState({ filtered: updatedList });
      return;
    }
    updatedList = updatedList.filter((item) => {
      return item.dog[0] !== undefined ? item.dog[0].name.toLowerCase().search(e.target.value.toLowerCase()) !== -1 : false;
    });
    this.setState({ filtered: updatedList });
  };
  formatRemainingSeconds(timeElapsed) {
    const seconds = timeElapsed / 1000;
    const times = {
      min: Math.floor(seconds / 60).toString(),
      sec: Math.floor(seconds % 60).toString(),
      msec: (seconds % 1).toFixed(2).substring(2),
    };
    return (
      this.leftPad(2, times.min) +
      ":" +
      this.leftPad(2, times.sec) +
      ":" +
      times.msec
    );
  }
  renderTimes() {
    const times = this.state.filtered.map((t, i) => {
      return (
        <Table.Row key={i}>
          <Table.Cell>{t.position}</Table.Cell>
          <Table.Cell>{t.dog[0]?.name}</Table.Cell>
          <Table.Cell>{t.dog[0]?.breed}</Table.Cell>
          <Table.Cell>{t.ticket?.owner}</Table.Cell>
          <Table.Cell>{moment(t.createdAt).format("DD/MM/YYYY HH:mm")}</Table.Cell>
          <Table.Cell textAlign="center">
            {this.formatRemainingSeconds(t.time)}
          </Table.Cell>
        </Table.Row>
      );
    });
    return (
      <Segment basic className="no-pad1" loading={this.state.loading}>
        <Header>Times</Header>
        <Table unstackable striped className="no-marg">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell collapsing>#</Table.HeaderCell>
              <Table.HeaderCell>Dog</Table.HeaderCell>
              <Table.HeaderCell>Breed</Table.HeaderCell>
              <Table.HeaderCell>Owner Initials</Table.HeaderCell>
              <Table.HeaderCell>Completed At</Table.HeaderCell>
              <Table.HeaderCell textAlign="center">
                Time (secs)
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>{times}</Table.Body>
        </Table>
      </Segment>
    );
  }
  render() {
    return (
      <Segment basic textAlign="center" className="no-hpad">
        <Button
          size="large"
          name="all"
          onClick={this.setDay}
          active={this.state.day === "all"}
        >
          All Weekend
        </Button>
        <Button
          size="large"
          name="saturday"
          onClick={this.setDay}
          active={this.state.day === "saturday"}
        >
          Saturday
        </Button>
        <Button
          size="large"
          name="sunday"
          onClick={this.setDay}
          active={this.state.day === "sunday"}
        >
          Sunday
        </Button>

        <Segment basic textAlign="center">
          <Input
            className="inputStyle searchBox"
            autoComplete="off"
            name="name"
            placeholder="Please enter your dogs name"
            icon="search"
            onChange={this.handleClientFilter}
          />
        </Segment>
        {this.renderTimes()}
      </Segment>
    );
  }
}
